import { render, staticRenderFns } from "./ClientDtiInfoHandler.vue?vue&type=template&id=697db33c&scoped=true&"
import script from "./ClientDtiInfoHandler.vue?vue&type=script&lang=js&"
export * from "./ClientDtiInfoHandler.vue?vue&type=script&lang=js&"
import style0 from "./ClientDtiInfoHandler.vue?vue&type=style&index=0&id=697db33c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697db33c",
  null
  
)

export default component.exports